<template>
  <div>
    <RightTitle title="更改头像"></RightTitle>
    <div class="uar_form">
      <div class="clear">
        <div class="myhead">
          <img
            class="myface"
            src="http://user.aizhanzhe.com/Public/Media/Head/2018050610294267615.jpg"
            width="200"
            height="200"
          />
        </div>
        <div class="myheadIntro red">如果你还没有设置自己的头像，系统会显示为默认头像，你需要自己上传一张新照片来作为自己的个人头像。</div>
      </div>
      <div class="ClearsH1"></div>
      <div>
        <el-button type="primary" @click="toggleShow(true)">上传头像</el-button>
        <my-upload
          field="img"
          :width="300"
          :height="300"
          url="/upload"
          :params="params"
          :headers="headers"
          :value.sync="show"
          img-format="png"
          @input="toggleShow"
        ></my-upload>
      </div>
    </div>
  </div>
</template>

<script>
import RightTitle from "../../../components/RightTitle";
import myUpload from "vue-image-crop-upload";
export default {
  name: "person_avatar",
  components: {
    RightTitle,
    'my-upload': myUpload
  },
  data() {
    return {
      show: false,
      params: {
        token: "123456798",
        name: "avatar"
      },
      headers: {
        smail: "*_~"
      }
    };
  },
  methods: {
    toggleShow(show) {
      this.show = show;
    }
  }
};
</script>

<style scoped>
.myhead {
  width: 200px;
  height: 200px;
  border: 1px solid #e6e6e6;
  padding: 5px;
  float: left;
  border-radius: 50%;
  overflow: hidden;
}
.myhead img {
  border-radius: 50%;
}
.myheadIntro {
  width: 630px;
  height: 200px;
  float: left;
  margin-left: 10px;
}
</style>